import { Brand } from "@/components/Brand";

export const Loader = ({ label = "Cargando…" }) => (
  <div className="min-h-screen flex flex-col items-center justify-center gap-5 bg-[#F8F9FA]" data-testid="loader">
    <div className="animate-pulse">
      <Brand size="lg" />
    </div>
    <div className="flex items-center gap-2 text-slate-500">
      <span className="h-2 w-2 rounded-full bg-[#13315C] animate-bounce" style={{ animationDelay: "0ms" }} />
      <span className="h-2 w-2 rounded-full bg-[#13315C] animate-bounce" style={{ animationDelay: "120ms" }} />
      <span className="h-2 w-2 rounded-full bg-[#13315C] animate-bounce" style={{ animationDelay: "240ms" }} />
      <span className="ml-2 text-sm">{label}</span>
    </div>
  </div>
);
